<template>
	<div id="market_detail">
		<leftnav class="fl"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="freeUserType" :bgtype="0"></freeUserTips>
			</el-dialog>
			<watermark :isShowMark='isshowWaterMark'>
				<div class="index_left_centerpage">
					<div class="whitebox py-3 download-position">
						<div @click="downloadPng" class="downloadPng"><i class="el-icon-download font-30 color-c4" title="保存为图片"></i></div>
						<div id="chart-download">
							<div id="baseInfoCharts" class="mt-6"></div>
							<p class="widthPC-75 margin-x-auto">数据来源：中投顾问产业研究大脑</p>
						</div>
					</div>
				</div>
			</watermark>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import { sortKey } from '@/utils/index.js'
import html2canvas from "html2canvas"
export default {
	name: 'bureauStatisticsDetail',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	components: {
	},
	data() {
		return {
			title:'统计局数据详情页',
			userdata: {},
			pageType: 1,
			code: '',
			baseInfo: {},
			showTable: false,
			isshowWaterMark: false, //是否显示水印
			isShowFreeUserTips:false, //是否显示免费用户提示
			freeUserType:2,
		}
	},
	beforeCreate() { },
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
		});
		// this.userdata = this.getuseriformation();
		this.code = this.$route.query.code;
		this.pageType = this.$route.query.type;
	},
	mounted() {
		window.scrollTo(0, 0);
		window.addEventListener("scroll", this.handleScroll, true);
		this.getPageDetail();
	},
	methods: {
		downloadPng() {
			let fileName = this.baseInfo.title;
			// 转换成canvas
			html2canvas(document.getElementById("chart-download")).then(function (canvas) {
				var img = canvas
					.toDataURL("image/png")
					.replace("image/png", "image/octet-stream");
				// 创建a标签，实现下载
				var creatIMg = document.createElement("a");
				creatIMg.download = fileName + ".png"; // 设置下载的文件名，
				creatIMg.href = img; // 下载url
				document.body.appendChild(creatIMg);
				creatIMg.click();
				creatIMg.remove(); // 下载之后把创建的元素删除
			});
		},
		getPageDetail() {
			var that = this;
			this.bus.$emit("loading", true);
			this.$axios.get(this.$api.cyl.statsData.detail() + "?code=" + this.code+"&dataType="+this.pageType).then(function (res) {
				if (res.data.success) {
					console.log(res);
					that.baseInfo = res.data.list[0] || [];
					document.title = that.baseInfo.title;
					that.$nextTick(() => {
							that.drawShape('baseInfoCharts', that.baseInfo.data, that.baseInfo.title, that.baseInfo.unit, 'show');
					})
					// that.getPageDetail2(that.baseInfo.notionCode);
					that.bus.$emit("loading", false);
				} else {

				}
			})
		},
	 

		drawShape(el, data, legendName, unit) {
			console.log(el,data,legendName,unit); 
			let xAxisText = [];
			let barData = [], //柱状
				lineData = []; //折线
			for (var i = 0; i < data.length; i++) { 
					let tempStr='';
					// xAxisText.push(data[i].year);
					if(this.pageType == 1){ //1年度 3月度 4季度
						tempStr = data[i].year+"年";
						xAxisText.push(tempStr);
					}else if(this.pageType == 3){
						tempStr = data[i].year +'-'+data[i].month+'月';
						xAxisText.push(tempStr);
					}else if(this.pageType == 4){
						tempStr = data[i].year +'-'+data[i].quarter+'季度';
						xAxisText.push(tempStr);
					}
					barData.push(data[i].value);
					lineData.push(data[i].growth);
			}
			//因为要从大到小按年份提取10条数据，所以前面按照从大到小排序了，但是柱状图又要从小到大排序，所以这里反转一下数据
			
				// 反转数据年份从小到大排序
				xAxisText.reverse();
				barData.reverse();
				lineData.reverse();
				this.cpclChart(el, xAxisText, lineData, barData, legendName, unit);
		},
		 
		cpclChart(el, xdata, lineData, barData, legendName, unit) {
			var mychart = echarts.init(document.getElementById(el));
			let min = Math.floor(Math.min(...barData));
			let max = Math.floor(Math.max(...barData));
			let lineMin = Math.floor(Math.min(...lineData));
			let lineMax = Math.floor(Math.max(...lineData));
			let range = max - min;
			min = min - (range / 1)
			// console.log(min,max,range);
			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					grid: {
						top: '20%',
					},
					// confine:true, //是否将提示框限制在图表的区域内
					appendToBody: true, //是否将提示框放置在body元素上
					formatter: function (params) {
						// console.log(params);
						var result = ''
						var name = params[0].name + "</br>";
						var dotHtml = '', dotHtml2 = '', unitd = params[0].componentSubType == "line" ? ' %' : unit;
						if (params[0]) {
							dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[0].color + '"></span> ' + params[0].seriesName + "： " + params[0].data + ' ' + unitd + "</br>"; // 定义第一个数据前的圆点颜色	
						}
						if (params[1]) {
							dotHtml2 = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[1].color + '"></span>' + params[1].seriesName + "： " + params[1].data + ' %';
						}

						result += name + dotHtml + dotHtml2;
						return result
					},
				},
				legend: {
					show: true,
					bottom: "10",
					itemGap: 30,
				 
				},
				xAxis: {
					type: 'category',
					data: xdata,
					interval: 0,
					axisLine: {
						onZero: false,
					}
					// axisLabel: { color: '#333', interval: 0, rotate: 50 }
				},
				yAxis: [
					{
						type: 'value',
						name: '',
						minInterval: 1,
						min: min,
						boundaryGap: false,
						// step:
						axisTick: {
							"show": true
						},
						axisLine: {
							show: true,
						}, //显示y轴刻度线
						splitLine: {
							show: false
						}, //不显示分割线
					},
					{
						type: 'value',
						name: ' ',
						min: lineMin,
						boundaryGap: false,
						axisTick: {
							"show": true
						},
						splitLine: {
							show: false
						}, //不显示分割线
						axisLine: {
							show: true,
						}, //显示y轴刻度线
						axisLabel: {
							// 使用 formatter 属性来格式化标签文本
							formatter: '{value} %' // 在这里添加单位
						}
					}
				],
				series: [
					{
						type: 'bar',
						name: legendName,
						color: 'rgb(96, 147, 218)',
						yAxisIndex: 0, // 这里指定使用第一个 Y 轴
						data: barData,
						barMaxWidth: 30,
						label: {
							show:   true,
							 // 绝对的像素值,避免折线数据和柱状数据重叠
  							position: [0, -30],
							// position: 'auto',
							formatter: '{c}'+unit,
						}
					},
					{
						name: 'YOY',
						type: 'line',
						yAxisIndex: 1,
						color: '#ffaf25',
						data: lineData,
						label: {
							show: true,
							position: 'auto',
							formatter: '{c}%'
						}
					}
				]
			}
			mychart.setOption(option)

		},
		 
		  
		// dmo元素里的内容转换为canvas,并将canvas下载为图片
		download() {
			// 转换成canvas
			html2canvas(document.getElementById("baseInfoCharts")).then(function (canvas) {
				var img = canvas
					.toDataURL("image/png")
					.replace("image/png", "image/octet-stream");
				// 创建a标签，实现下载
				var creatIMg = document.createElement("a");
				creatIMg.download = "图表.png"; // 设置下载的文件名，
				creatIMg.href = img; // 下载url
				document.body.appendChild(creatIMg);
				creatIMg.click();
				creatIMg.remove(); // 下载之后把创建的元素删除
			});
		},
	}
}
</script>

<style>
.market-list {
    width: calc(33% - 35px);
    height: 365px;
    cursor: pointer;
    overflow: hidden;
    transition: all .3s;
    border: 1px solid #eee;
    margin-right: 35px;
    border-radius: 8px;
}
.market-title {
    padding: 20px 20px 0 20px;
    height: 48px;
}
#baseInfoCharts {
	width: 95%;
	height: 700px;
	/* border: 1px solid red; */
	margin: 0 auto;
}

.market-chain-img {
	width: 95%;
	margin: 0 auto;
	padding-bottom: 10px;
}
.download-position{
	position: relative;
	
}
.download-position .downloadPng{
	cursor: pointer;
	position: absolute;
	right: 11%;
	top: 25px;
	z-index: 99;
}

</style>